<template>
  <BaseTable
    :isLoading="isLoading"
    :tableData="data"
    :totalItemsCount="totalItemsCount"
    :perPage="perPage"
    :currentPage="currentPage"
    :showSearch="true"
    searchPlaceholder="Search by name, account group, customer id"
    :showCreateButton="isGlobalAdmin"
    createLabel="New CSP"
    @create="$emit('openModal')"
    @search="onSearch"
    @clear="onClear"
    @paginate="paginate"
  >
    <template #columns>
      <Column field="name" header="Name" :styles="{ 'min-width': '10rem' }">
        <template #body="{ data }">
          <p>{{ data.name }}</p>
        </template>
      </Column>
      <Column header="P44 Account Group">
        <template #body="{ data }">
          {{ data.p44_account_group }}
        </template>
      </Column>
      <Column header="Parent Account ID">
        <template #body="{ data }">
          {{ data.parent_account_id && data.parent_account_id.name }}
        </template>
      </Column>
      <Column :styles="{ 'min-width': '10rem' }" header="Customers Id's">
        <template #body="{ data }">
          <div v-for="(customer, index) in data.customer_ids" :key="index">
            {{ customer.name }}
          </div>
        </template>
      </Column>
    </template>

    <!-- Read only for non global admins: writes are global admin only -->
    <template v-if="isGlobalAdmin" #actions-column>
      <Column header="Actions">
        <template #body="{ data }">
          <div class="data-table__actions">
            <span @click="$emit('openModal', data)"><i class="pi pi-pencil"></i></span>
            <span @click="deleteRow(data)"><i class="pi pi-trash"></i></span>
          </div>
        </template>
      </Column>
    </template>
  </BaseTable>
</template>

<script>
import { mapGetters } from "vuex";
import { successMessage, deleteMessage } from "@/utils/alertMessages";
import BaseTable from "./BaseTable.vue";

export default {
  name: "CSPTable",
  components: { BaseTable },
  emits: ["openModal"],
  data() {
    return {
      isLoading: false,
      data: [],
      totalItemsCount: 0,
      currentPage: 1,
      perPage: 15,
    };
  },
  computed: {
    ...mapGetters("user", ["showCurrentCompanyDepartment"]),
    isGlobalAdmin() {
      const userInfo = JSON.parse(localStorage.getItem("user-info") || "null");
      return userInfo?.role === "global_admin";
    },
  },
  async created() {
    await this.getAllCSP();
  },
  methods: {
    async getAllCSP(params) {
      this.isLoading = true;
      const payload = { limit: 15, skip: (this.currentPage - 1) * 15 };
      if (params?.name) payload.q = params.name;
      const response = await this.$store.dispatch("csp/getAllACSP", payload);
      this.data = response.data;
      this.totalItemsCount = response.count;
      this.isLoading = false;
    },
    async onSearch(term) {
      if (term) {
        this.currentPage = 1;
        await this.getAllCSP({ name: term });
      }
    },
    async onClear() {
      this.currentPage = 1;
      await this.getAllCSP();
    },
    async paginate(page) {
      this.currentPage = page;
      await this.getAllCSP();
      window.scrollTo(0, 0);
    },
    async deleteRow(cspData) {
      const msg = "Are you sure you want to remove CSP from the system?";
      const warningResponse = await deleteMessage(msg, "You won't be able to revert this!");
      if (warningResponse.isConfirmed) {
        const response = await this.$store.dispatch("csp/deleteCSP", cspData.id);
        if (response.status === 204) {
          if (this.data.length === 1 && this.currentPage > 1) this.currentPage -= 1;
          await this.getAllCSP();
          successMessage("CSP has been deleted");
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@include table-action-icons;
</style>
